import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskChangePriority } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { SessionServerSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskChangePriorityAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksPriority,
  translateName: Messages.tasksSetPriority_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const ignoreExtractTaskPriority: boolean =  SessionServerSelectors.ignoreExtractTaskPriority(state);
    return !ignoreExtractTaskPriority && targetItems.length > 0;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangePriority(targetItems)
};
